let btnBookDetail = document.querySelector(".btn-book-detail");

if (btnBookDetail) {
	btnBookDetail.addEventListener("click", function (e) {
		e.preventDefault();
		$("#m-booking-detail").modal("show");
		// setTimeout(function () {
		// 	$("#m-booking-detail").modal("hide");
		// }, 5000);
	});
}
